<template>
  <div>
    <Nav/>
    <div v-if="currentUser" class="page home-page">
      <Sidebar />
      <main class="column p-8">
        <h1 class="text-darkgrey">
          Willkommen {{ displayGender }}
          {{ currentUser.title }}
          <br />
          {{ currentUser.firstname }} {{ currentUser.lastname }}!
        </h1>
        <p class="text-darkgrey">
          Auf dieser <router-link to="/">Startseite</router-link> finden Sie
          Neuigkeiten rund um FactField sowie Informationen zu Neuerungen in
          unserem im Login-Bereich.
        </p>

        <p class="text-darkgrey">
          Über das
          <router-link to="/benchmarks">Benchmarking-Dashboard</router-link>
          können Sie, sofern Sie an der Befragung zur FOCUS-Ärzteliste 2021
          teilgenommen haben, Ihren eigenen Status in Bezug auf die von
          FactField für die Identifikation der Top-Mediziner genutzten
          Qualitätsindikatoren einsehen und Ihre Kennzahlen mit denen von
          befragten Ärzten und von FOCUS ausgezeichneten TOP-Medizinern 2021
          vergleichen. Perspektivisch werden wir Ihnen im Login-Bereich weitere
          Funktionalitäten und zusätzliche Produkte rund um medizinische
          Qualität zur Verfügung stellen.
        </p>
        <p class="text-darkgrey">
          Ihre Account- und Login-Daten sowie Benachrichtigungen können Sie über
          die Seite
          <router-link to="/profile">Mein Account</router-link> verwalten.
        </p>
      </main>
    </div>
    <LoginDialog
      :closable="false"
      v-if="
        login ||
        (!forgot_password &&
          !newsletter_optin &&
          !reset_password &&
          !confirmed &&
          !pre_confirmed &&
          !currentUser)
      "
      @close="
        !pre_confirmed &&
        !confirmed &&
        !forgot_password &&
        !newsletter_optin &&
        !reset_password &&
        !currentUser
          ? closeLogin
          : undefined
      "
    />
    <ResetPasswordDialog v-if="!login && reset_password" />
    <ForgotPasswordDialog
      v-if="!login && forgot_password"
      :visible="forgot_password"
    />
    <NewsletterOptinDialog v-if="!login && newsletter_optin" />
    <AccountActivatedDialog v-if="!login && confirmed" />
    <AccountPreActivatedDialog v-if="!login && pre_confirmed" />
  </div>
</template>

<script>
import LoginDialog from "@/components/Dialog/LoginDialog";
import ResetPasswordDialog from "@/components/Dialog/ResetPasswordDialog";
import Sidebar from "@/components/Layout/Sidebar";
import ForgotPasswordDialog from "@/components/Dialog/ForgotPasswordDialog";
import NewsletterOptinDialog from "@/components/Dialog/NewsletterOptinDialog";
import AccountPreActivatedDialog from "@/components/Dialog/AccountPreActivatedDialog";
import AccountActivatedDialog from "@/components/Dialog/AccountActivatedDialog";
import Nav from "@/components/Layout/Nav";

export default {
  name: "Home",
  components: {
    Nav,
    ForgotPasswordDialog,
    Sidebar,
    ResetPasswordDialog,
    LoginDialog,
    NewsletterOptinDialog,
    AccountPreActivatedDialog,
    AccountActivatedDialog,
  },
  props: {
    login: {
      type: Boolean,
      default: () => false,
      required: false,
    },
    forgot_password: {
      type: Boolean,
      default: () => false,
      required: false,
    },
    reset_password: {
      type: Boolean,
      default: () => false,
      required: false,
    },
    newsletter_optin: {
      type: Boolean,
      default: () => false,
      required: false,
    },
    pre_confirmed: {
      type: Boolean,
      default: () => false,
      required: false,
    },
    confirmed: {
      type: Boolean,
      default: () => false,
      required: false,
    },
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    displayGender() {
      return this.currentUser.gender === "male"
        ? "Herr"
        : this.currentUser.gender === "female"
        ? "Frau"
        : "";
    },
  },
  methods: {
    closeLogin() {},
  },
};
</script>

<style scoped lang="postcss">
.page {
  @apply gap-0;
}
main {
  p {
    @apply my-4;

    @screen lg {
      max-width: 75%;
    }
  }
}
</style>
